import React, { useState } from 'react';
import Navbar from '../Customer/Navbar';

const MutualFundCalculator = () => {
  const [activeTab, setActiveTab] = useState('calculator');

  const largeCapFunds = [
    
  ];

  const midCapFunds = [
    
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="py-8 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-16 pt-12 text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-2">Mutual Fund Calculator</h1>
          </div>

         
        </div>
      </div>
    </div>
  );
};

export default MutualFundCalculator;
